// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"f37f450d","100":"8f3028c7","142":"e18d9739","272":"d79e47e0","292":"21b05069","677":"cfb0bc87"}[chunkId] + ".chunk.css";
};